<template>
  <path
    d="M8 19.0002C9.1 19.0002 10 18.1002 10 17.0002V7.00018C10 5.90018 9.1 5.00018 8 5.00018C6.9 5.00018 6 5.90018 6 7.00018V17.0002C6 18.1002 6.9 19.0002 8 19.0002ZM14 7.00018V17.0002C14 18.1002 14.9 19.0002 16 19.0002C17.1 19.0002 18 18.1002 18 17.0002V7.00018C18 5.90018 17.1 5.00018 16 5.00018C14.9 5.00018 14 5.90018 14 7.00018Z"
  />
</template>
